import { IOpenAuthModalParameters } from 'shared/types/microfrontends/header-frontend';
import { ensureHeaderMicrofrontend } from '../../microfrontend';

export async function openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void> {
  const microfrontend = await ensureHeaderMicrofrontend();

  return microfrontend?.call('/v2/open-auth-modal/', parameters);
}
